import { Edition } from '@atlassian/touchpoint-commons-event-analytics';

import type { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'startTrial',
	dialogId: 'free-choose-your-edition-modal',
	dialogType: 'modal',
	targetProductEdition: Edition.SELECTION,
};
